@let projectEngagements = projectEngagementsSg();

@if (projectEngagements) {
  <div class="atn-summit-org-chart-node-panel-project-engagements-tab">
    <div class="atn-summit-org-chart-node-panel__table">
      <div class="atn-summit-org-chart-node-panel__table-row">
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Project Name
          </div>
        </div>
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Period
          </div>
        </div>
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Role
          </div>
        </div>
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Description
          </div>
        </div>
      </div>
      @for (project of projectEngagements; track $index) {
        <div class="atn-summit-org-chart-node-panel__table-row">
          <div class="atn-summit-org-chart-node-panel__table-column">
            {{ project.projectName }}
          </div>
          <div class="atn-summit-org-chart-node-panel__table-column">
            {{ project.period?.start | date: 'shortDate' : 'UTC' }} -
            {{ project.period?.end | date: 'shortDate' : 'UTC' }}
          </div>
          <div class="atn-summit-org-chart-node-panel__table-column">
            {{ project.role }}
          </div>
          <div
            class="atn-summit-org-chart-node-panel__table-column"
            [atnDsEllipsisTooltip]="project.description"
          >
            {{ project.description }}
          </div>
        </div>
      } @empty {
        No project engagements...
      }
    </div>
  </div>
}
